import React from "react";
import { Spinner } from "@chakra-ui/core";
import { Icon } from "../icon";
import { PlaceholderLoading } from "../forms/PlaceholderLoading";
import { formatDate } from "../helpers";
import { Capitalize } from "../../../libs/formatting";
import { pxToRem } from "../../../utils/dimensionConverter";
import { EXCLUDED_HEALTH_PLANS } from "../../../const/constants";

export const LayoutHeader = ({
  title,
  hasBack,
  hasActions,
  actionComponent,
  big,
  onBack,
}) => {
  return (
    <div className={`layout-header ${big && "layout-header--big"}`}>
      <div className="layout-header__title">
        {hasBack && (
          <button className="icon-back" onClick={onBack}>
            <Icon name="left-arrow" size={pxToRem(10)} />
          </button>
        )}
        <span>{title}</span>
      </div>
      {hasActions && (
        <div className="layout-header__action">{actionComponent}</div>
      )}
    </div>
  );
};

export const StatusTag = ({ status }) => {
  let statusText, statusClass;
  if (status === "Complete") {
    statusText = "Complete";
    statusClass = "complete";
  } else {
    statusText = "In Progress";
    statusClass = "in-progress";
  }

  return (
    <div className={`status status--${statusClass}`}>
      <span className="status__light"></span>
      <span className="status__text">{statusText}</span>
    </div>
  );
};

export const LoadLayout = ({ isLoading, message, children }) => {
  if (isLoading) {
    return (
      <div className="loading-layout">
        <div className="layout-spinner">
          <Spinner
            size="md"
            speed="1s"
            emptyColor="#EFEEEF"
            thickness={pxToRem(4)}
            color="#93328E"
          />
          {message && (
            <span className="loading-layout__message">{message}</span>
          )}
        </div>
      </div>
    );
  }
  return children;
};

export const UserInfoList = ({
  userInfo,
  isModal,
  loading,
}) => {
  const { fullName, subscriberId, healthPlan, lineOfBusiness, dob } = userInfo;

  const userData = [
    { label: "Name", data: Capitalize(fullName, 'name') },
    { label: "Subscriber ID", data: subscriberId },
    { label: "Health Plan", data: healthPlan },
    { label: "Line of Business", data: Capitalize(lineOfBusiness) },
    { label: "DOB", data: formatDate(dob) },
  ];

  return (
    <section className={`summary ${isModal && "summary--modal"}`}>
      <ul className="summary__list">
        {userData.map(({ label, data }) => (
          <UserInfoItem key={label} label={label} data={data} loading={loading} />
        ))}
      </ul>
    </section>
  );
};

const UserInfoItem = ({ label, data, loading }) => (
  <li className="summary__item">
    <div className="summary__name">{label} </div>
    {loading ? (
      <PlaceholderLoading />
    ) : (
      <div className="summary__sub">{data || <br />}</div>
    )}
  </li>
);